<template>
  <div>
    <Select @on-select="select" v-model="temp" :filterable='filterable' :placeholder='placeholder' :transfer='transfer' :multiple='multiple' :disabled='disabled'>
      <Option v-for="item in dicList" :value="item.id" :key="item.id">{{
        item.dicDisplay
      }}</Option>
    </Select>
  </div>
</template>

<script>
import Util from '@/libs/util'
export default {
  name: 'dicSelect',
  data () {
    return {
      dicList: [],
      temp: this.value
    }
  },
  props: {
    dicType: {
      type: Number
    },
    value: {
      type: [String, Array, Number]
    },
    filterable: {
      type: Boolean,
      default: false
    },
    transfer: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择'
    }
  },
  methods: {
    getDic () {
      let params = {
        dicType: this.dicType,
        size: 9999
      }
      Util.http.get(`/api/cscpDics/getDicByType`, { params }).then(res => {
        this.dicList = res.data.list
      })
    },
    select (e) {
      this.$nextTick(() => {
        this.$emit('input', this.temp)
        this.$emit('on-Select', e)
      })
    }
  },
  mounted () {
    this.getDic()
  }
}
</script>

<style lang="less" scoped></style>
